"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const js_base64_1 = require("js-base64");
const GlobalData_1 = require("../Utility/GlobalData");
const User_1 = require("../User/User");
const Config_1 = require("../Config/Config");
const LoginUser_1 = require("../User/LoginUser");
const FetchProxy_1 = require("../Utility/FetchProxy");
class Authorization {
    constructor() {
        this.initialized = false;
        this.onReadyCallback = () => { };
        this.onUserAuthLostCallback = () => { };
    }
    get currentUser() {
        return GlobalData_1.currentUser;
    }
    async initialize() {
        const token = localStorage.getItem('token');
        if (token === null) {
            this.onReadyCallback();
            this.initialized = true;
            return;
        }
        try {
            const newToken = await this.refreshToken(token);
            (0, GlobalData_1.setCurrentUser)(new LoginUser_1.default(newToken));
            localStorage.setItem('token', token);
        }
        catch (err) {
            (0, GlobalData_1.setCurrentUser)(undefined);
            localStorage.removeItem('token');
        }
        finally {
            this.onReadyCallback();
            this.initialized = true;
        }
    }
    async loginWithTempToken(tempToken) {
        (0, GlobalData_1.setCurrentUser)(new LoginUser_1.default(tempToken, true));
    }
    async refreshToken(token) {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user/refresh_token`, {
                headers: { 'Authorization': token }
            }).fetch();
            if (res.status === 200) {
                return await res.text();
            }
            return token;
        }
        catch (err) {
            throw new Error(`Failed to reset token: status ${err.message}`);
        }
    }
    async getUserById(id) {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user/get/full?userId=${id}`).auth().fetch();
            const user = await res.json();
            return new User_1.default(user);
        }
        catch (err) {
            throw new Error(`Failed to get user: status ${err.message}`);
        }
    }
    async getPartialUserById(id) {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user/get/partial?userId=${id}`).auth().fetch();
            return await res.json();
        }
        catch (err) {
            throw new Error(`Failed to get partial user by id: status ${err.message}`);
        }
    }
    async getPartialUserByPhone(phone) {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user/get/partial?phone=${phone}`).auth().fetch();
            return await res.json();
        }
        catch (err) {
            throw new Error(`Failed to get partial user by phone: status ${err.message}`);
        }
    }
    async createClientUser(token, clientInfo) {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user/create`, {
                method: 'POST',
                headers: { 'Authorization': token },
                body: JSON.stringify({
                    name: clientInfo.name,
                    email: clientInfo.email,
                    pass: clientInfo.pass
                })
            }).fetch();
            return res.text();
        }
        catch (err) {
            throw new Error(`Failed to create client user: status ${err.message}`);
        }
    }
    async verifyUser(phone, verifyCode) {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user/verify`, {
                method: 'POST',
                body: JSON.stringify({
                    phone: phone,
                    verifyCode: verifyCode
                })
            }).fetch();
            return res.text();
        }
        catch (err) {
            throw new Error(`User verification failed: status ${err.message}`);
        }
    }
    async verifySendSMS(phone) {
        try {
            await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user/send_verify?phone=${phone}`).fetch();
        }
        catch (err) {
            throw new Error(`Cannot get user SMS verification: status ${err.message}`);
        }
    }
    async userLogin(phone, password) {
        const basicToken = js_base64_1.Base64.encode(`${phone}:${password}`);
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user/login`, {
                headers: { 'Authorization': `Basic ${basicToken}` }
            }).fetch();
            const token = await res.text();
            (0, GlobalData_1.setCurrentUser)(new LoginUser_1.default(token));
            localStorage.setItem('token', token);
        }
        catch (err) {
            throw new Error(`Login failed: status ${err.message}`);
        }
        return this.currentUser;
    }
    logout() {
        if (GlobalData_1.currentUser === undefined) {
            return;
        }
        new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/user/logout`).auth().fetch();
        localStorage.removeItem('token');
        this.userAuthLost();
    }
    onReady(callback) {
        if (this.initialized) {
            callback();
        }
        else {
            this.onReadyCallback = callback;
        }
    }
    ;
    onUserAuthLost(callback) {
        this.onUserAuthLostCallback = callback;
        return () => {
            this.onUserAuthLostCallback = () => { };
        };
    }
    userAuthLost() {
        (0, GlobalData_1.setCurrentUser)(undefined);
        this.onUserAuthLostCallback();
    }
}
exports.default = Authorization;
//# sourceMappingURL=Authorization.js.map